import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import moment from 'moment';
import { AppService, ValueIdPair } from 'src/app/_services/app.service';
import { ManageCalendarComponent } from '../manage-calendar.component';

export const MY_FORMATS = {
  parse: {
    dateInput: 'D MMM YYYY',
  },
  display: {
    dateInput: 'D MMM YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
    selector: 'app-add-holiday',
    templateUrl: './add-holiday.component.html',
    providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})
export class AddHolidayComponent implements OnInit {

  holiday: Holiday;
  markets: ValueIdPair[];
  hasStatDays: Boolean = false;
  constructor(public service: AppService, public dialogRef: MatDialogRef<ManageCalendarComponent>, @Inject(MAT_DIALOG_DATA) public data, @Inject('BASE_URL') private baseUrl: string, private http: HttpClient) { }

  ngOnInit() {
    this.GetExceptionMarkets();
    this.InitializeForm();
    if (this.service.isUpdateHoliday === true) {
      this.PopulateForm();
    }
  }

  /** Gets the exception markets  */
  GetExceptionMarkets() {
    this.http.get<ValueIdPair[]>(this.baseUrl + 'api/calendar/getExceptionMarkets').subscribe(result => {
      this.markets = result;
    }, error => {
      console.error(error);
    });
  }

  /** Resets the date filter */
  ResetDateFilter() {
    this.holiday.statutoryDate = null;
  }

  /** Save button event */
  OnSaveHoliday() {
    if (this.holiday.description && this.holiday.actualDate) {
      this.holiday.actualDate = moment(this.holiday.actualDate).format('YYYY-MM-DD');
      if (this.holiday.statutoryDate) {
        this.holiday.statutoryDate = moment(this.holiday.statutoryDate).format('YYYY-MM-DD');
      }
      this.service.isUpdateHoliday = false;
      this.dialogRef.close(this.holiday);
    }
  }

  /** Populates the form */
  PopulateForm() {
    this.holiday = {
      holidayId: this.data.holiday.holidayId,
      actualDate: this.data.holiday.actualDate,
      statutoryDate: this.data.holiday.statutoryDate,
      description: this.data.holiday.description,
      exceptions: this.data.holiday.exceptions
    };
    this.hasStatDays = this.data.hasStatDays;
  }

  /** Initializes the form */
  InitializeForm() {
    this.holiday = {
      holidayId: '',
      actualDate: null,
      statutoryDate: null,
      description: '',
      exceptions: []
    };
  }

  /** Cancel button event */
  OnCancel() {
    this.dialogRef.close(null);
  }
}

/** An interface to access holiday details */
interface Holiday {
  holidayId: string;
  description: string;
  actualDate: string;
  statutoryDate: string;
  exceptions: string[];
}
